import { showMedicalContentSelector } from '@/redux/config/selfData';
import React from 'react';
import { useSelector } from 'react-redux';
import { MedicalDfreeGraphList } from './medical';
import { ProDfreeGraphList } from './professional';

export const DfreeGraphList: React.FC = () => {
  const showMedicalContent = useSelector(showMedicalContentSelector);

  return showMedicalContent ? <MedicalDfreeGraphList /> : <ProDfreeGraphList />;
};
